'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _handleActions;

var _reduxActions = require('redux-actions');

var _navigation = require('../actions/navigation');

var actions = _interopRequireWildcard(_navigation);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty3['default'])(_handleActions, actions.setDockedSidebar, function (state, action) {
  var dockedSidebar = action.payload.dockedSidebar;


  return (0, _extends3['default'])({}, state, {
    dockedSidebar: dockedSidebar
  });
}), (0, _defineProperty3['default'])(_handleActions, actions.setOpenSidebar, function (state, action) {
  var openSidebar = action.payload.openSidebar;


  return (0, _extends3['default'])({}, state, {
    openSidebar: openSidebar
  });
}), _handleActions), {

  dockedSidebar: false,
  openSidebar: false

});


//////////////////
// WEBPACK FOOTER
// ./program/frontend/reducers/navigation.js
// module id = 868
// module chunks = 0